module.exports = __webpack_public_path__ + "img/10crage.c27cb6b1.png";